import React from 'react';
import classnames from 'classnames';

import * as Classes from '../common/classes';

import { BadgeCountIntent } from '../common/props';

type BadgeCountProps = {
  /**
   * Typ informace.
   */
  intent?: BadgeCountIntent;
  insetted?: boolean;
  count: number;
};

export const BadgeCount: React.FC<BadgeCountProps> = ({ intent, insetted = true, count, children }) => {
  const computedClassName = classnames(Classes.BADGE_COUNT, {
    [Classes.BADGE_COUNT_INSETTED]: insetted,
  }, {
    [Classes.BADGE_COUNT_DEFAULT]: !intent || intent  === 'default',
    [Classes.BADGE_COUNT_DANGER]: intent === 'danger',
    [Classes.BADGE_COUNT_WARNING]: intent === 'warning',
    [Classes.BADGE_COUNT_SUCCESS]: intent === 'success',
    [Classes.BADGE_COUNT_SECONDARY]: intent === 'secondary',
  });
  
  return (
    <div className={computedClassName}>
      {children}
      <span className={Classes.BADGE_COUNT_NUMBER}>{count}</span>
    </div>
  );
};
